import React from 'react';

export default function Commercial() {
  return (
    <main>
      <div className="heading text-center py-8 bg-gray-100">
        <h3 className="text-4xl font-semibold">Commercial Projects</h3>
        <p className="text-gray-600">
          <a href="/">home</a> / Commercial
        </p>
      </div>
      {/* Add your Commercial case studies or gallery here */}
    </main>
  );
}
